var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "cmp cmp-product-thumb", class: _vm.itemClass },
    [
      _c(
        "div",
        {
          class: _vm.paddingClasses + " " + _vm.thumbContainerClass,
          style: _vm.paddingInlineStyles,
        },
        [
          _vm.showBasket
            ? [
                _c("custom-add-to-basket", {
                  attrs: {
                    "data-testing": "item-add-to-basket",
                    "variation-id": _vm.selectedVariation.variation.id,
                    "is-salable":
                      !!_vm.selectedVariation.filter &&
                      _vm.selectedVariation.filter.isSalable,
                    "has-children":
                      !!_vm.selectedVariation.item &&
                      _vm.selectedVariation.item.salableVariationCount > 1,
                    "interval-quantity":
                      _vm.selectedVariation.variation.intervalOrderQuantity ||
                      1,
                    "minimum-quantity":
                      _vm.selectedVariation.variation.minimumOrderQuantity,
                    "maximum-quantity":
                      !!_vm.selectedVariation.variation.maximumOrderQuantity &&
                      _vm.selectedVariation.variation.maximumOrderQuantity > 0
                        ? _vm.selectedVariation.variation.maximumOrderQuantity
                        : null,
                    "order-properties": _vm.selectedVariation.properties.filter(
                      function (prop) {
                        return prop.property.isOderProperty
                      }
                    ),
                    "has-order-properties":
                      _vm.selectedVariation.hasOrderProperties,
                    "has-required-order-property":
                      _vm.selectedVariation.hasRequiredOrderProperty,
                    "use-large-scale": true,
                    "show-quantity": false,
                    "item-url": _vm._f("itemURL")(
                      _vm.selectedVariation,
                      _vm.urlWithVariationId
                    ),
                    "has-price": _vm._f("hasItemDefaultPrice")(
                      _vm.selectedVariation
                    ),
                    "has-graduated-price":
                      _vm.itemGraduatedPriceisCheapestSorting ||
                      _vm.itemGraduatedPricesalableVariationCount,
                    "item-type": _vm.selectedVariation.item.itemType,
                    "basket-not-salable-icon": _vm.basketNotSalableIcon,
                    "basket-salable-icon": _vm.basketSalableIcon,
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-2", class: _vm.thumbImageClass },
            [
              _vm._t("store-special", [
                _vm.storeSpecial ||
                _vm.item.variation.bundleType === "bundle" ||
                _vm.item.item.itemType === "set" ||
                !_vm.item.filter.isSalable ||
                _vm.selectedVariation.tags
                  ? _c("custom-item-store-special", {
                      attrs: {
                        "store-special": _vm.storeSpecial,
                        "recommended-retail-price": _vm.item.prices.rrp,
                        "variation-retail-price": _vm.item.prices.default,
                        "special-offer-price": _vm.item.prices.specialOffer,
                        "decimal-count": _vm.decimalCount,
                        "bundle-type": _vm.item.variation.bundleType,
                        "item-type": _vm.item.item.itemType,
                        "is-salable":
                          !!_vm.item.item &&
                          _vm.item.item.salableVariationCount > 0,
                        "badge-available-class": _vm.badgeClass,
                        "badge-available-text": _vm.badgeText,
                        "display-av-badge": _vm.enableBadge,
                        "enable-tag-badge": _vm.enableTagBadge,
                        "badge-position": _vm.badgePosition,
                        "selected-variation": _vm.selectedVariation,
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { class: "prop-" + _vm.aspectRatio },
                [
                  _vm._t("item-image", [
                    _c("custom-category-image", {
                      ref: "CustomCategoryImage",
                      attrs: {
                        "image-urls-data": _vm._f("itemImages")(
                          _vm.selectedVariation.images,
                          _vm.imageUrlAccessor
                        ),
                        alt: _vm._f("itemName")(_vm.item),
                        title: _vm._f("itemName")(_vm.item),
                        "item-url": _vm._f("itemURL")(
                          _vm.selectedVariation,
                          _vm.urlWithVariationId
                        ),
                        "enable-carousel":
                          _vm.$ceres.config.item.enableImageCarousel,
                        "disable-carousel-on-mobile":
                          _vm.disableCarouselOnMobile,
                        "is-salable-item":
                          !!_vm.item.item &&
                          _vm.item.item.salableVariationCount > 0,
                        "enable-av-overlay": _vm.enableOverlay,
                        "item-identification":
                          _vm.selectedVariation.variation.id,
                      },
                    }),
                  ]),
                ],
                2
              ),
            ],
            2
          ),
          _vm._v(" "),
          _vm.entries.length > 0
            ? _c(
                "div",
                { class: _vm.thumbContentClass },
                [
                  _vm._l(_vm.entries, function (entry) {
                    return [
                      entry.thumbFieldSelection === "title"
                        ? [
                            _c(
                              "a",
                              {
                                staticClass: "title-thumb",
                                class:
                                  entry.titleSettings.titleTextColor +
                                  " " +
                                  entry.titleSettings.titleAlign +
                                  " " +
                                  entry.titleSettings.customClass,
                                attrs: {
                                  href: _vm._f("itemURL")(
                                    _vm.item,
                                    _vm.urlWithVariationId
                                  ),
                                },
                              },
                              [
                                entry.titleSettings.titleSelect === "name1"
                                  ? [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.item.texts.name1) +
                                          "\n            "
                                      ),
                                    ]
                                  : entry.titleSettings.titleSelect === "name2"
                                  ? [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.item.texts.name2) +
                                          "\n            "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.item.texts.name3) +
                                          "\n            "
                                      ),
                                    ],
                                _vm._v(" "),
                                entry.titleSettings.showItemAttributes
                                  ? [
                                      _vm._l(
                                        _vm.selectedVariation.groupedAttributes,
                                        function (attribute) {
                                          return [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    "Ceres::Template.itemGroupedAttribute",
                                                    attribute
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        }
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      entry.thumbFieldSelection === "description" &&
                      _vm.item.texts.shortDescription !== ""
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "description-thumb",
                                class:
                                  entry.descriptionSettings
                                    .descriptionTextColor +
                                  " " +
                                  entry.descriptionSettings.descriptionAlign +
                                  " " +
                                  entry.descriptionSettings.customClass,
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.item.texts.shortDescription) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      entry.thumbFieldSelection === "prices"
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "prices-thumb",
                                class:
                                  entry.priceSettings.finalPriceAlign +
                                  " " +
                                  entry.priceSettings.customClass,
                              },
                              [
                                entry.priceSettings.showRrp &&
                                entry.priceSettings.rrpPosition === "left" &&
                                _vm.selectedVariation.prices.rrp &&
                                _vm.selectedVariation.prices.rrp.price.value >
                                  0 &&
                                _vm.selectedVariation.prices.rrp.price.value >
                                  _vm.selectedVariation.prices.default.price
                                    .value
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "before-price" },
                                        [
                                          _vm.selectedVariation.prices
                                            .specialOffer
                                            ? _c(
                                                "del",
                                                { staticClass: "crossprice" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "itemCrossPrice"
                                                        )(
                                                          _vm.selectedVariation
                                                            .prices.default
                                                            .unitPrice
                                                            .formatted,
                                                          true
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "del",
                                                { staticClass: "crossprice" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "itemCrossPrice"
                                                        )(
                                                          _vm.selectedVariation
                                                            .prices.rrp
                                                            .unitPrice.formatted
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "final-price",
                                          class: entry.priceSettings.rrpColor,
                                        },
                                        [
                                          _vm.selectedVariation.item
                                            .itemType === "set"
                                            ? [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemSetPrice",
                                                        {
                                                          price:
                                                            _vm.itemSetPrice,
                                                        }
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFootnote"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            : _vm.itemGraduatedPriceisCheapestSorting
                                            ? [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFromPrice",
                                                        {
                                                          price:
                                                            _vm.itemPriceGraduated,
                                                        }
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFootnote"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            : _vm.itemGraduatedPricesalableVariationCount
                                            ? [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFromPrice",
                                                        {
                                                          price:
                                                            _vm.itemPriceGraduated,
                                                        }
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFootnote"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm._f("specialOffer")(
                                                        _vm.selectedVariation
                                                          .prices.default
                                                          .unitPrice.formatted,
                                                        _vm.selectedVariation
                                                          .prices,
                                                        "unitPrice",
                                                        "formatted"
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFootnote"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                    ]
                                  : entry.priceSettings.showRrp &&
                                    entry.priceSettings.rrpPosition ===
                                      "right" &&
                                    _vm.selectedVariation.prices.rrp &&
                                    _vm.selectedVariation.prices.rrp.price
                                      .value > 0 &&
                                    _vm.selectedVariation.prices.rrp.price
                                      .value >
                                      _vm.selectedVariation.prices.default.price
                                        .value
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "final-price",
                                          class: entry.priceSettings.rrpColor,
                                        },
                                        [
                                          _vm.selectedVariation.item
                                            .itemType === "set"
                                            ? [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemSetPrice",
                                                        {
                                                          price:
                                                            _vm.itemSetPrice,
                                                        }
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFootnote"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            : _vm.itemGraduatedPriceisCheapestSorting
                                            ? [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFromPrice",
                                                        {
                                                          price:
                                                            _vm.itemPriceGraduated,
                                                        }
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFootnote"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            : _vm.itemGraduatedPricesalableVariationCount
                                            ? [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFromPrice",
                                                        {
                                                          price:
                                                            _vm.itemPriceGraduated,
                                                        }
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFootnote"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm._f("specialOffer")(
                                                        _vm.selectedVariation
                                                          .prices.default
                                                          .unitPrice.formatted,
                                                        _vm.selectedVariation
                                                          .prices,
                                                        "unitPrice",
                                                        "formatted"
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.itemFootnote"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "before-price" },
                                        [
                                          _vm.selectedVariation.prices
                                            .specialOffer
                                            ? _c(
                                                "del",
                                                { staticClass: "crossprice" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "itemCrossPrice"
                                                        )(
                                                          _vm.selectedVariation
                                                            .prices.default
                                                            .unitPrice
                                                            .formatted,
                                                          true
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "del",
                                                { staticClass: "crossprice" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "itemCrossPrice"
                                                        )(
                                                          _vm.selectedVariation
                                                            .prices.rrp
                                                            .unitPrice.formatted
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                    ]
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "final-price",
                                        class:
                                          entry.priceSettings.finalPriceColor,
                                      },
                                      [
                                        _vm.selectedVariation.item.itemType ===
                                        "set"
                                          ? [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.itemSetPrice",
                                                      {
                                                        price: _vm.itemSetPrice,
                                                      }
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.itemFootnote"
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          : _vm.itemGraduatedPriceisCheapestSorting
                                          ? [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.itemFromPrice",
                                                      {
                                                        price:
                                                          _vm.itemPriceGraduated,
                                                      }
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.itemFootnote"
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          : _vm.itemGraduatedPricesalableVariationCount
                                          ? [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.itemFromPrice",
                                                      {
                                                        price:
                                                          _vm.itemPriceGraduated,
                                                      }
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.itemFootnote"
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm._f("specialOffer")(
                                                      _vm.selectedVariation
                                                        .prices.default
                                                        .unitPrice.formatted,
                                                      _vm.selectedVariation
                                                        .prices,
                                                      "unitPrice",
                                                      "formatted"
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.itemFootnote"
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                _vm._v(" "),
                                _vm._t("after-prices"),
                                _vm._v(" "),
                                _vm.selectedVariation.prices.default.lowestPrice
                                  .value && _vm.hasCrossPrice
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "category-lowest-price small",
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.itemLowestPrice",
                                                {
                                                  price:
                                                    _vm.selectedVariation.prices
                                                      .default.lowestPrice
                                                      .formatted,
                                                }
                                              )
                                            ),
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                entry.priceSettings.showUnitPrice
                                  ? [
                                      !(
                                        _vm.selectedVariation.unit
                                          .unitOfMeasurement === "C62" &&
                                        _vm.selectedVariation.unit.content === 1
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "unit-price small" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedVariation.unit
                                                      .content
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.selectedVariation.unit
                                                        .names.name
                                                    )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _vm.selectedVariation.variation
                                                .mayShowUnitPrice
                                                ? _c("span", [
                                                    _vm._v(
                                                      " | " +
                                                        _vm._s(_vm.basePrice)
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      entry.thumbFieldSelection === "cart"
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "basket-thumb",
                                class: entry.cartSettings.customClass,
                              },
                              [
                                _c("custom-add-to-basket", {
                                  attrs: {
                                    "variation-id":
                                      _vm.selectedVariation.variation.id,
                                    "is-salable":
                                      !!_vm.selectedVariation.filter &&
                                      _vm.selectedVariation.filter.isSalable,
                                    "has-children":
                                      !!_vm.selectedVariation.item &&
                                      _vm.selectedVariation.item
                                        .salableVariationCount > 1,
                                    "interval-quantity":
                                      _vm.selectedVariation.variation
                                        .intervalOrderQuantity || 1,
                                    "minimum-quantity":
                                      _vm.selectedVariation.variation
                                        .minimumOrderQuantity,
                                    "maximum-quantity":
                                      !!_vm.selectedVariation.variation
                                        .maximumOrderQuantity &&
                                      _vm.selectedVariation.variation
                                        .maximumOrderQuantity > 0
                                        ? _vm.selectedVariation.variation
                                            .maximumOrderQuantity
                                        : null,
                                    "order-properties":
                                      _vm.selectedVariation.properties.filter(
                                        function (prop) {
                                          return prop.property.isOderProperty
                                        }
                                      ),
                                    "has-order-properties":
                                      _vm.selectedVariation.hasOrderProperties,
                                    "has-required-order-property":
                                      _vm.selectedVariation
                                        .hasRequiredOrderProperty,
                                    "use-large-scale": false,
                                    "show-quantity": false,
                                    "item-url": _vm._f("itemURL")(
                                      _vm.item,
                                      _vm.urlWithVariationId
                                    ),
                                    "has-price": _vm._f("hasItemDefaultPrice")(
                                      _vm.item
                                    ),
                                    "has-graduated-price":
                                      _vm.itemGraduatedPriceisCheapestSorting ||
                                      _vm.itemGraduatedPricesalableVariationCount,
                                    "item-type":
                                      _vm.selectedVariation.item.itemType,
                                    "basket-not-salable-icon":
                                      _vm.basketNotSalableIcon,
                                    "basket-salable-icon":
                                      _vm.basketSalableIcon,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      entry.thumbFieldSelection === "vat"
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "vat-thumb text-muted",
                                class:
                                  entry.vatSettings.vatAlign +
                                  " " +
                                  entry.vatSettings.customClass,
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemFootnote"
                                      )
                                    ) +
                                    "\n            "
                                ),
                                !_vm.showNetPrices
                                  ? [
                                      entry.vatSettings.vatShowPercentage &&
                                      _vm.selectedVariation.prices.default.vat
                                        .value > 0
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemIncludeAbbr"
                                                  )
                                                ) +
                                                "\n                " +
                                                _vm._s(
                                                  _vm.selectedVariation.prices
                                                    .default.vat.value
                                                ) +
                                                "%\n                " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.basketVAT"
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.itemInclVAT"
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.itemExclVAT"
                                          )
                                        )
                                      ),
                                    ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemExclusive"
                                      )
                                    ) +
                                    "\n            "
                                ),
                                _vm.$ceres.config.global
                                  .shippingCostsCategoryId > 0
                                  ? _c(
                                      "a",
                                      {
                                        class: entry.vatSettings.vatToggleColor,
                                        attrs: {
                                          "data-toggle": "modal",
                                          href: "#shippingscosts",
                                          title: _vm.$translate(
                                            "Ceres::Template.itemShippingCosts"
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemShippingCosts"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "a",
                                      {
                                        attrs: {
                                          title: _vm.$translate(
                                            "Ceres::Template.itemShippingCosts"
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.itemShippingCosts"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                              ],
                              2
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      entry.thumbFieldSelection === "availability" &&
                      _vm.selectedVariation.variation.availability.names.name
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "availability-thumb",
                                class:
                                  entry.availabilitySettings.availabilityAlign +
                                  " " +
                                  entry.availabilitySettings.customClass,
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.wishListAvailability"
                                      )
                                    ) +
                                    " - " +
                                    _vm._s(
                                      _vm.selectedVariation.variation
                                        .availability.names.name
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      entry.thumbFieldSelection === "properties" &&
                      _vm.item.variationProperties
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "properties-thumb",
                                class:
                                  entry.propertySettings.propertyAlign +
                                  " " +
                                  entry.propertySettings.customClass,
                              },
                              [
                                _vm.isPreview
                                  ? [
                                      entry.propertySettings.showProperty
                                        ? _c("strong", [
                                            _vm._v("Property Name: "),
                                          ])
                                        : _vm._e(),
                                      _vm._v("Property Value\n            "),
                                    ]
                                  : [
                                      _vm._l(
                                        _vm.item.variationProperties,
                                        function (properyGroup) {
                                          return [
                                            _vm._l(
                                              properyGroup.properties,
                                              function (property) {
                                                return [
                                                  property.values.value !== ""
                                                    ? [
                                                        _c("div", [
                                                          entry.propertySettings
                                                            .showProperty
                                                            ? _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    property
                                                                      .names
                                                                      .name
                                                                  ) + ": "
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                property.values
                                                                  .value
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]),
                                                      ]
                                                    : _vm._e(),
                                                ]
                                              }
                                            ),
                                          ]
                                        }
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      entry.thumbFieldSelection === "variations" &&
                      _vm.variationsData != null &&
                      _vm.typeOfVariation === "image"
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "variations-thumb",
                                class: entry.variationsSettings.customClass,
                              },
                              [
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "nav justify-content-center v-s-boxes images",
                                  },
                                  _vm._l(
                                    _vm.variationsData.documents,
                                    function (variation) {
                                      return _c(
                                        "li",
                                        {
                                          staticClass:
                                            "nav-item m-2 v-s-box bg-white",
                                          class: _vm.variationClass(
                                            variation.data.attributes[0].value
                                              .id,
                                            variation.data.filter.isSalable
                                          ),
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectVariation(
                                                variation.data,
                                                variation.data.attributes[0]
                                                  .value.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          variation.data.attributes[0].value
                                            .image !== ""
                                            ? _c("img", {
                                                staticClass: "p-1",
                                                attrs: {
                                                  alt: variation.data
                                                    .attributes[0].value
                                                    .backendName,
                                                  src:
                                                    "/images/produkte/grp/" +
                                                    variation.data.attributes[0]
                                                      .value.image,
                                                },
                                              })
                                            : _c(
                                                "span",
                                                { staticClass: "mx-3" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      variation.data
                                                        .attributes[0].value
                                                        .names.name
                                                    )
                                                  ),
                                                ]
                                              ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      entry.thumbFieldSelection === "feedback"
                        ? _c(
                            "div",
                            {
                              staticClass: "feedback-thumb",
                              class:
                                entry.feedbackSettings.feedbackAlign +
                                " " +
                                entry.feedbackSettings.customClass,
                            },
                            [_vm._t("before-prices")],
                            2
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }